import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, Alert, Spinner } from 'react-bootstrap';
import espholter from '../../../assets/esp-holter.png';
import { getPrefix } from '../../../util/utils';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';
import useHolter from '../../../hooks/useHolter';

export default function EspelhoHolter() {
  const { id } = useParams();
  const { data: holter, error, isLoading } = useHolter(id);
  const laudoHolter = holter?.[0];

  return (
    <Card style={{ fontSize: 24, marginTop: 10, marginBottom: 10 }}>
      <LaudoCardHeader title="LAUDO DE HOLTER" />

      {error && !isLoading && (
        <Alert variant="danger" style={{ marginTop: 10 }}>
          <Alert.Heading>Erro ao carregar laudo de holter!</Alert.Heading>
          <p>Tente novamente.</p>
        </Alert>
      )}

      {isLoading && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <Spinner animation="border" variant="dark" size="lg" />
        </div>
      )}

      {!isLoading && !error && laudoHolter && (
        <>
          <Card.Body>
            <strong className="mr-auto">Cod Holter: </strong>
            {laudoHolter.CODHOLTER}&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Nome do Paciente: </strong>
            {`${laudoHolter.CODPAC} - ${laudoHolter.NOMEPAC}`}
            <br></br>
            <strong className="mr-auto">Data de Nasc: </strong>
            {`${laudoHolter.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Sexo: </strong>
            {`${laudoHolter.SEXOPAC}`}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {`${laudoHolter.idadePAC} anos`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Alt: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Peso: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">SC: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br></br>
            <strong className="mr-auto">Convênio: </strong>
            {laudoHolter.DESCRICONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {laudoHolter.dataHolter}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br></br>
            <strong className="mr-auto">
              Médico que Solicitou: {getPrefix(laudoHolter.CODSOLICITANTE)}{' '}
            </strong>
            {`${laudoHolter.Solicitou}`}
            <hr></hr>
            <div>
              <img
                width="95%"
                height="60%"
                loading="lazy"
                src={espholter}
                alt="espelho holter"
              />{' '}
            </div>
          </Card.Body>
          <Card.Footer id="removeMe" className="text-center">
            <Button variant="outline-primary" onClick={() => window.print()}>
              Imprimir
            </Button>
          </Card.Footer>
        </>
      )}
    </Card>
  );
}
